/**
 * Syncs line item property "Meters" to quantity / 2 before checkout, then redirects.
 */
(function () {
  if (window.__meterCheckoutSyncInit) return;
  window.__meterCheckoutSyncInit = true;

  function metersFromQuantity(qty) {
    const units = parseInt(qty, 10);
    if (!units || units < 0) return '0';
    const meters = units / 2;
    return meters % 1 === 0 ? String(meters) : meters.toFixed(1);
  }

  function normalizeProperties(properties) {
    if (!properties) return {};
    if (Array.isArray(properties)) {
      return properties.reduce((acc, entry) => {
        if (entry && entry.key != null) acc[entry.key] = entry.value;
        return acc;
      }, {});
    }
    return { ...properties };
  }

  function getCartLineRow(lineIndex) {
    const line = lineIndex + 1;
    return (
      document.getElementById(`CartDrawer-Item-${line}`) ||
      document.getElementById(`CartItem-${line}`)
    );
  }

  function isMeterLineItem(item, lineIndex) {
    const properties = normalizeProperties(item.properties);
    if (properties.Meters != null && properties.Meters !== '') return true;

    const meterVariantIds = (window.meterProductVariantIds || []).map(Number);
    if (meterVariantIds.includes(Number(item.variant_id))) return true;

    const row = getCartLineRow(lineIndex);
    return row?.dataset.meterProduct === 'true';
  }

  function postCartChange(payload) {
    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig()
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          };

    return fetch(`${window.routes.cart_change_url}`, {
      ...config,
      body: JSON.stringify(payload),
    });
  }

  async function parseCartChangeResponse(response) {
    const text = await response.text();
    let data = {};
    try {
      data = JSON.parse(text);
    } catch (error) {
      if (!response.ok) throw new Error('Cart update failed');
      return data;
    }
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }
    return data;
  }

  async function syncMeterPropertiesBeforeCheckout() {
    const cartResponse = await fetch(`${window.routes.cart_url}.js`);
    if (!cartResponse.ok) throw new Error('Could not load cart');

    const cart = await cartResponse.json();

    for (let index = 0; index < cart.items.length; index++) {
      const item = cart.items[index];
      if (!isMeterLineItem(item, index)) continue;

      const properties = normalizeProperties(item.properties);
      const expected = metersFromQuantity(item.quantity);
      const current = properties.Meters;

      if (String(current) === expected) continue;

      const changeResponse = await postCartChange({
        id: item.key,
        quantity: item.quantity,
        properties: { ...properties, Meters: expected },
      });

      await parseCartChangeResponse(changeResponse);
    }
  }

  function goToCheckout() {
    const checkoutUrl = window.routes?.checkout_url || '/checkout';
    window.location.assign(checkoutUrl);
  }

  function setCheckoutLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.toggleAttribute('aria-busy', isLoading);
    if (isLoading) {
      button.dataset.meterCheckoutOriginalLabel = button.textContent;
      button.textContent = button.dataset.meterCheckoutLoadingLabel || '...';
    } else if (button.dataset.meterCheckoutOriginalLabel) {
      button.textContent = button.dataset.meterCheckoutOriginalLabel;
      delete button.dataset.meterCheckoutOriginalLabel;
    }
  }

  function showCheckoutError(message) {
    const errorsEl = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errorsEl) {
      errorsEl.textContent = message;
    } else {
      alert(message);
    }
  }

  async function handleCheckoutClick(event, button) {
    if (button.dataset.meterCheckoutProcessing === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const form = button.getAttribute('form')
      ? document.getElementById(button.getAttribute('form'))
      : button.closest('form');

    if (!form && !window.routes?.checkout_url) return;

    event.preventDefault();
    event.stopPropagation();

    button.dataset.meterCheckoutProcessing = 'true';
    setCheckoutLoading(button, true);

    try {
      await syncMeterPropertiesBeforeCheckout();
      goToCheckout();
    } catch (error) {
      console.error('[meter-checkout-sync]', error);
      button.dataset.meterCheckoutProcessing = 'false';
      showCheckoutError('Could not update fabric meters. Please try again.');
      setCheckoutLoading(button, false);
    }
  }

  function initMeterCheckoutSync() {
    document.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
        if (!button || button.disabled) return;

        handleCheckoutClick(event, button);
      },
      true
    );
  }

  window.syncMeterPropertiesBeforeCheckout = syncMeterPropertiesBeforeCheckout;
  window.metersFromQuantity = metersFromQuantity;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMeterCheckoutSync);
  } else {
    initMeterCheckoutSync();
  }
})();
